const List = () => {
    return (
        <ul className="list">
            <li className="list-item">
                <div className="list-key">sampleKey1</div>
                <div className="list-value">
                    <span>sampleValue1</span>
                </div>
            </li>
            <li className="list-item">
                <div className="list-key">sampleKey2</div>
                <div className="list-value">
                    <span>sampleValue2</span>
                </div>
            </li>
            <li className="list-item">
                <div className="list-key">sampleKey3</div>
                <div className="list-value">
                    <span>sampleValue3</span>
                </div>
            </li>
        </ul>
    );
};

export default List;
